<template>
  <div class="home padding-top-xbig">
    <div class="container padding-bottom-big">
      <div class="align-center">
        <p class="ink-lighter-1 font-size-xbig margin-vertical-xbig">Você não tem nenhum projeto :(</p>
        <b-button class="font-size-normal" @clickOrEnter="addProject({name: 'Novo Projeto', releases: []})">Adicionar projeto</b-button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import BButton from '@/dls/components/Button.vue'
import AppRelease from '@/components/Release.vue'

export default {
  name: 'home',
  components: {
    BButton,
    AppRelease
  },
  methods: {
    addProject(project) {
      this.$store.dispatch('addProject', project).then((project) => {
        this.$router.push(`/project/${project.id}`);
      });
    }
  },
  mounted() {
    if (typeof(Storage) !== "undefined" && window.localStorage.getItem('projects')) {
      this.$store.commit('setProjects', {projects: JSON.parse(window.localStorage.getItem('projects'))});
    }
    if (typeof(Storage) !== "undefined") {
      if(window.localStorage.getItem('currentProjectId')) {
        var projectId = window.localStorage.getItem('currentProjectId')
        this.$router.push(`/project/${projectId}`);
      } else {
        var projects = JSON.parse(window.localStorage.getItem('projects'));
        if(projects && projects.length>0) {
          var projectId = projects[0].id;
          this.$router.push(`/project/${projectId}`);
        }
      }
    }
  }
}
</script>
